import Modal from "@/components/common/modal";
import { useUIStore } from "../store/uiStore";
import {
  Avatar,
  AvatarFallback,
  Button,
  Icon,
} from "@elaniintc/goes-design-system";

const NodeValidationSuccessModal = () => {
  const { setModalState, setSelectedErrors } = useUIStore();

  return (
    <Modal
      isOpen={true}
      onClose={() => {
        setModalState("idle");
        setSelectedErrors(undefined);
      }}
      title="Resumen de prueba"
      description="Aquí tienes un vistazo de la validación de todos los nodos dentro de este flujo."
      modalContentClassName="w-full max-w-[var(--size-horizontal-sm)]"
    >
      <div className="pt-8 flex flex-col gap-8">
        <div className="rounded-lg bg-surface-sucess-accent-quiet text-success flex gap-2 p-2">
          <Avatar size="sm" shape="square">
            <AvatarFallback shape="square" type="icon" color="success">
              <Icon type="fas" name="check" />
            </AvatarFallback>
          </Avatar>
          <p className="text-lg leading-4xl font-normal">
            Configuraciones válidas en todos los nodos.
          </p>
        </div>
        <Button
          variant="tertiary"
          className="w-full"
          onClick={() => {
            setModalState("idle");
            setSelectedErrors(undefined);
          }}
        >
          Aceptar
        </Button>
      </div>
    </Modal>
  );
};

export default NodeValidationSuccessModal;
